<div class="side-nav" role="navigation" aria-label="Primary">
  <ul
    class="ant-menu ant-menu-root ant-menu-inline side-nav-menu"
    [ngClass]="{
      'ant-menu-inline-collapsed': isFolded || isCompactView,
      'ant-menu-dark': isSideNavDark
    }"
  >
    <ng-container *ngFor="let item of menuItems">
      <ng-container [ngSwitch]="item.submenu.length > 0">
        <li
          *ngSwitchCase="true"
          [ngClass]="{
            'ant-menu-submenu': true,
            'ant-menu-submenu-inline': true,
            'ant-menu-submenu-open': isSubmenuOpen(item) || hasActiveChild(item),
            'ant-menu-submenu-selected': hasActiveChild(item)
          }"
        >
          <button
            type="button"
            class="ant-menu-submenu-title"
            (click)="toggleSubmenu(item, $event)"
            nz-tooltip
            [nzTooltipTitle]="isCompactView ? item.title : null"
            [nzTooltipDisabled]="!isCompactView"
            nzTooltipPlacement="right"
            [attr.aria-expanded]="(isSubmenuOpen(item) || hasActiveChild(item)) ? 'true' : 'false'"
            aria-haspopup="true"
          >
            <div class="side-nav-flex-align-items-center">
              <i *ngIf="item.iconType === 'nzIcon'" nz-icon [nzType]="item.icon" class="opacity-07 font-size-25" [theme]="item.iconTheme"></i>
              <span class="side-nav__title-text">{{ item.title }}</span>
              <i class="ant-menu-submenu-arrow"></i>
            </div>
          </button>

          <ul
            class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu"
            *ngIf="isSubmenuOpen(item) || hasActiveChild(item)"
          >
            <li
              *ngFor="let subItem of item.submenu"
              [ngClass]="{
                'ant-menu-submenu': subItem.submenu.length > 0,
                'ant-menu-submenu-inline': subItem.submenu.length > 0,
                'ant-menu-submenu-open': isSubmenuOpen(subItem) || hasActiveChild(subItem),
                'ant-menu-submenu-selected': hasActiveChild(subItem),
                'ant-menu-item': subItem.submenu.length === 0,
                'ant-menu-item-selected': subItem.submenu.length === 0 && isRouteSelected(subItem)
              }"
            >
              <button
                type="button"
                class="ant-menu-submenu-title p-l-50"
                *ngIf="subItem.submenu.length > 0"
                (click)="toggleSubmenu(subItem, $event)"
                nz-tooltip
                [nzTooltipTitle]="isCompactView ? subItem.title : null"
                [nzTooltipDisabled]="!isCompactView"
                nzTooltipPlacement="right"
                [attr.aria-expanded]="(isSubmenuOpen(subItem) || hasActiveChild(subItem)) ? 'true' : 'false'"
                aria-haspopup="true"
              >
                <i *ngIf="subItem.iconType === 'nzIcon'" nz-icon [nzType]="subItem.icon" class="opacity-07 font-size-25" [theme]="subItem.iconTheme"></i>
                <span class="side-nav__title-text">{{ subItem.title }}</span>
                <i class="ant-menu-submenu-arrow"></i>
              </button>
              <a
                [routerLink]="subItem.path"
                [queryParams]="subItem.queryParams || null"
                (click)="closeMobileMenu()"
                class="p-l-30"
                *ngIf="subItem.submenu.length === 0"
                nz-tooltip
                [nzTooltipTitle]="isCompactView ? subItem.title : null"
                [nzTooltipDisabled]="!isCompactView"
                nzTooltipPlacement="right"
              >
                <div class="side-nav-flex-align-items-center">
                  <i *ngIf="subItem.iconType === 'nzIcon'" nz-icon [nzType]="subItem.icon" class="opacity-07 font-size-25" [theme]="subItem.iconTheme"></i>
                  <div class="side-nav__title-group">
                    <span class="side-nav__title-text">{{ subItem.title }}</span>
                    <span *ngIf="subItem.subtitle" class="side-nav__title-subtext">{{ subItem.subtitle }}</span>
                  </div>
                </div>
              </a>
              <ul
                class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu"
                *ngIf="subItem.submenu.length > 0 && (isSubmenuOpen(subItem) || hasActiveChild(subItem))"
              >
                <li
                  *ngFor="let nestedItem of subItem.submenu"
                  [ngClass]="{
                    'ant-menu-submenu': nestedItem.submenu.length > 0,
                    'ant-menu-submenu-inline': nestedItem.submenu.length > 0,
                    'ant-menu-submenu-open': isSubmenuOpen(nestedItem) || hasActiveChild(nestedItem),
                    'ant-menu-submenu-selected': hasActiveChild(nestedItem),
                    'ant-menu-item': nestedItem.submenu.length === 0,
                    'ant-menu-item-selected': nestedItem.submenu.length === 0 && isRouteSelected(nestedItem)
                  }"
                >
                  <button
                    type="button"
                    class="ant-menu-submenu-title p-l-60"
                    *ngIf="nestedItem.submenu.length > 0"
                    (click)="toggleSubmenu(nestedItem, $event)"
                    nz-tooltip
                    [nzTooltipTitle]="isCompactView ? nestedItem.title : null"
                    [nzTooltipDisabled]="!isCompactView"
                    nzTooltipPlacement="right"
                    [attr.aria-expanded]="(isSubmenuOpen(nestedItem) || hasActiveChild(nestedItem)) ? 'true' : 'false'"
                    aria-haspopup="true"
                  >
                    <i *ngIf="nestedItem.iconType === 'nzIcon'" nz-icon [nzType]="nestedItem.icon" class="opacity-07 font-size-25" [theme]="nestedItem.iconTheme"></i>
                    <span class="side-nav__title-text">{{ nestedItem.title }}</span>
                    <i class="ant-menu-submenu-arrow"></i>
                  </button>
                  <a
                    [routerLink]="nestedItem.path"
                    [queryParams]="nestedItem.queryParams || null"
                    (click)="closeMobileMenu()"
                    class="p-l-50"
                    *ngIf="nestedItem.submenu.length === 0"
                    nz-tooltip
                    [nzTooltipTitle]="isCompactView ? nestedItem.title : null"
                    [nzTooltipDisabled]="!isCompactView"
                    nzTooltipPlacement="right"
                  >
                    <div class="side-nav-flex-align-items-center">
                      <i *ngIf="nestedItem.iconType === 'nzIcon'" nz-icon [nzType]="nestedItem.icon" class="opacity-07 font-size-25" [theme]="nestedItem.iconTheme"></i>
                      <div class="side-nav__title-group">
                        <span class="side-nav__title-text">{{ nestedItem.title }}</span>
                        <span *ngIf="nestedItem.subtitle" class="side-nav__title-subtext">{{ nestedItem.subtitle }}</span>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li
          *ngSwitchDefault
          class="ant-menu-item"
          routerLinkActive="ant-menu-item-selected"
          [routerLinkActiveOptions]="{ exact: !item.matchSubRoutes }"
        >
          <a
            [routerLink]="item.path"
            [queryParams]="item.queryParams || null"
            (click)="closeMobileMenu()"
            nz-tooltip
            [nzTooltipTitle]="isCompactView ? item.title : null"
            [nzTooltipDisabled]="!isCompactView"
            nzTooltipPlacement="right"
          >
            <div class="side-nav-flex-align-items-center">
              <i *ngIf="item.iconType === 'nzIcon'" nz-icon [nzType]="item.icon" class="opacity-07 font-size-25" [theme]="item.iconTheme"></i>
              <span class="side-nav__title-text">{{ item.title }}</span>
            </div>
          </a>
        </li>
      </ng-container>
    </ng-container>
  </ul>
</div>
